
import axios from 'axios';
import urls from './urls';
import * as qs from 'query-string';

export const assemblyTypesAPIs = {
    addAssemblyType: async (payload: {
        name: string,
        description?: string;
    }) => {
        try {
            const headers = {
                "Authorization": `Bearer ${localStorage.getItem("accessToken")}`,
                'Content-type': "application/json"
            }
            const response = await axios.post(urls.assemblyTypes, { ...payload}, {headers});
            return response.data;
        } catch (error) {
            let err: any = error;
            return err.error;
        }
    },
    getAssemblyTypesData: async (payload: {
        pageNumber: number;
        limit: number;
        searchText?: string;
    }) => {
        try {
            const headers = {
                "Authorization": `Bearer ${localStorage.getItem("accessToken")}`
            }
            let params: any = {
                "pageNumber": payload.pageNumber,
                "limit": payload.limit,
            }

            if (payload.searchText) {
                params.searchText = payload.searchText
            }

            let response = await axios.get(urls.assemblyTypes, {
                params,
                paramsSerializer: params => qs.stringify(params),
                headers });
            return response.data.data;
        } catch (error) {
            console.log(error);
            
            let err: any = error;
            return err.error;
        }
    },
    deleteAssemblyType: async (payload: any) => {
        try {
            const headers = {
                "Authorization": `Bearer ${localStorage.getItem("accessToken")}`,
            }
            const response = await axios.delete(`${urls.assemblyTypes}/${payload.id}`, {headers});
            return response.data;
        } catch (error) {
            let err: any = error;
            return err.error;
        }
    },
}